var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("反馈管理")]),
              _c("el-breadcrumb-item", [_vm._v("金点子列表")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        { attrs: { loading: _vm.tableLoading } },
        [
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.loadTableData },
                  },
                  [_vm._v("刷新")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.tableData.length)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: { slot: "content", data: _vm.tableData, border: "" },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "createDate",
                  align: "center",
                  label: "创建时间",
                  width: "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(scope.row.createDate))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "mobile",
                  align: "center",
                  label: "手机号",
                  width: "200",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "content", align: "left", label: "金点子内容" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }